export const DEFAULT_ROUTE: string = '/analytics';
export const RCON_ROUTE: string = '/receptionist-console';
